import { _decorator } from 'cc';
import InfiniteScrollView from '../ScrollView/InfiniteScrollView';
import OrientedComponent, { OrientedBaseProperty } from './OrientedComponent';

const { ccclass, property, requireComponent, menu } = _decorator;

@ccclass('OrientedInfiniteScrollViewProperties')
class OrientedInfiniteScrollViewProperties extends OrientedBaseProperty {
    @property
    public readonly updateMaxVisibleCount: boolean = false;
    @property({
        visible(this: OrientedInfiniteScrollViewProperties) {
            return this.updateMaxVisibleCount;
        },
    })
    public readonly maxVisibleCount = 10;

    @property
    public readonly updateMaxVisibleColCount: boolean = false;
    @property({
        visible(this: OrientedInfiniteScrollViewProperties) {
            return this.updateMaxVisibleColCount;
        },
    })
    public readonly maxVisibleColCount = 10;

    @property
    public readonly updateMaxVisibleRowCount: boolean = false;
    @property({
        visible(this: OrientedInfiniteScrollViewProperties) {
            return this.updateMaxVisibleRowCount;
        },
    })
    public readonly maxVisibleRowCount = 10;

    @property
    public readonly updatePaddingTop: boolean = false;
    @property({
        visible(this: OrientedInfiniteScrollViewProperties) {
            return this.updatePaddingTop;
        },
    })
    public readonly paddingTop = 0;

    @property
    public readonly updatePaddingBottom: boolean = false;
    @property({
        visible(this: OrientedInfiniteScrollViewProperties) {
            return this.updatePaddingBottom;
        },
    })
    public readonly paddingBottom = 0;

    @property
    public readonly updateSpacingY: boolean = false;
    @property({
        visible(this: OrientedInfiniteScrollViewProperties) {
            return this.updateSpacingY;
        },
    })
    public readonly spacingY = 0;

    @property
    public readonly updateItemHeight: boolean = false;
    @property({
        visible(this: OrientedInfiniteScrollViewProperties) {
            return this.updateItemHeight;
        },
    })
    public readonly itemHeight = 0;
    @property
    public readonly updateItemWidth: boolean = false;
    @property({
        visible(this: OrientedInfiniteScrollViewProperties) {
            return this.updateItemWidth;
        },
    })
    public readonly itemWidth = 0;
}

@ccclass('OrientedInfiniteScrollView')
@requireComponent(InfiniteScrollView)
@menu('Orientation/OrientedInfiniteScrollView')
export default class OrientedInfiniteScrollView extends OrientedComponent<InfiniteScrollView> {
    @property({ type: OrientedInfiniteScrollViewProperties, group: '橫式' })
    public readonly landscapeProperties: OrientedInfiniteScrollViewProperties = null;
    @property({ type: OrientedInfiniteScrollViewProperties, group: '直式' })
    public readonly portraitProperties: OrientedInfiniteScrollViewProperties = null;

    protected updateOrientationProperties(properties: OrientedInfiniteScrollViewProperties) {
        if (properties.updateMaxVisibleCount) {
            this.target.maxVisibleCount = properties.maxVisibleCount;
        }
        if (properties.updateMaxVisibleColCount) {
            this.target.maxVisibleColCount = properties.maxVisibleColCount;
        }
        if (properties.updateMaxVisibleRowCount) {
            this.target.maxVisibleRowCount = properties.maxVisibleRowCount;
        }
        if (properties.updatePaddingTop) {
            this.target.paddingTop = properties.paddingTop;
        }
        if (properties.updatePaddingBottom) {
            this.target.paddingBottom = properties.paddingBottom;
        }
        if (properties.updateSpacingY) {
            this.target.spacingY = properties.spacingY;
        }
        if (properties.updateItemHeight) {
            this.target.itemHeight = properties.itemHeight;
        }
        if (properties.updateItemWidth) {
            this.target.itemWidth = properties.itemWidth;
        }
        this.target.updateLayout();
    }

    protected getTarget() {
        return this.getComponent(InfiniteScrollView);
    }
}
